import { whatsappUrl } from "../../config/siteConfig";
import { WhatsAppIcon } from "./icons";

// Botão flutuante de WhatsApp: discreto, não cobre conteúdo nem controles.
// Só aparece quando o número oficial está configurado em siteConfig.
export const FloatingWhatsApp = () => {
    if (!whatsappUrl) return null;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Falar com a Linkora no WhatsApp"
            data-testid="floating-whatsapp"
            className="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-[#2563eb] hover:bg-[#1d4ed8] text-white flex items-center justify-center shadow-lg shadow-blue-600/30 transition-colors"
        >
            <WhatsAppIcon className="w-5 h-5" />
        </a>
    );
};
